import {Injectable} from '@angular/core';
import { HTTP_INTERCEPTORS, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {mergeMap, Observable} from 'rxjs';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {environment} from '../../../environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private readonly oidcSecurityService: OidcSecurityService) {
  }

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return this.oidcSecurityService.getIdToken().pipe(
      mergeMap((token: string): Observable<HttpEvent<unknown>> => {
        const isLoggedIn = token?.length;
          const isApiUrl = req.url.includes(environment.backendUrl + environment.backendUri);
          if (isLoggedIn > 0 && isApiUrl) {
            req = req.clone({
              withCredentials: true,
              setHeaders: {
                Authorization: `Bearer ${token}`
              }
            });
          } else {
            req = req.clone({
              withCredentials: true
            });
          }
          return next.handle(req);
      })
    );
  }
}

export const authInterceptorProviders = [
  {provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true},
];
